import common from "@page/common/js/common";
// import $ from 'jquery';

import freelayout from "@global/components/Home/freelayout";
import popup from "@global/components/Home/popup"; //首頁popup

require("@global/vendors/slick");

const HomeContent = function () {
	$(window).scroll();
	$(".main").css({ visibility: "visible" }).addClass("js-loaded");
	$(".home-loading").fadeOut();
	if (!nowEnv.NowMyEquipment) {
		// $('.home-IG__slider').slick({
		//   dots: false,
		//   speed: 2000,
		//   slidesToShow: 5,
		//   slidesToScroll: 5,
		//   autoplay: false,
		//   pauseOnHover: false,
		//   arrows: true
		// })
	}
};

HomeContent();

freelayout.initSlick();
freelayout.transitionEffects();

import globalLayout from "@global/components/Home/globalLayout"; //公版模組

globalLayout({
	banner: {
		isopen: false,
		opts: {
			dots: false,
			arrows: false,
			speed: 800,
			autoplay: true,
			autoplaySpeed: 3000,
		},
		squareOpts: {
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 3,
			dots: false,
			arrows: true,
			speed: 800,
			responsive: [
				{
					breakpoint: 415,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						arrows: false,
						centerMode: true,
						dots: false,
					},
				},
			],
		},
		fullbanner: {
			play: 5000,
		},
	},
	popupOpen: true,
	popupShowOnce: false,
});
